import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

import CartPanel from "../components/newOrders/CartPanel.comp";
import HeldCartPanel from "../components/newOrders/HeldCartPanel.comp";
import CategoryBreadcrumbsComp from "../components/orderProductPanel/categoryBreadcrumbs.comp";
import CategoriesLink from "../components/orderProductPanel/categoryLink.comp";
import OrderPanelLayout from "../components/orderProductPanel/orderPanelLayout.comp";
import ProductHomeLink from "../components/orderProductPanel/productHomeLink.comp";
import PosProductCard from "../components/prodcut/productList.comp";
import ProductListPaging from "../components/prodcut/productListPaging.comp";
import { ProductListFilter } from "../types/product";

export default function OrderProductPage() {
  const router = useRouter();
  const { query } = router;

  const methods = useForm<ProductListFilter>({
    defaultValues: {
      page: 2,
      pageSize: 20,
      search: query.search as string,
    },
  });

  return (
    <div className="relative">
      <OrderPanelLayout>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-6">
            <NavLink />

            <CategoryBreadcrumbsComp showAllCategoryInRoot={false} />
          </div>
        </div>

        {query.cartOpen === "true" && (
          <div className="lg:hidden absolute top-7 z-10 left-0 w-full">
            {query.mode !== "heldCart" ? <CartPanel /> : <HeldCartPanel />}
          </div>
        )}

        <PosProductCard methods={methods} />

        <div className="flex-center lg:block">
          <ProductListPaging methods={methods} />
        </div>
      </OrderPanelLayout>
    </div>
  );
}

function NavLink() {
  const { query } = useRouter();
  const catId = query.catId as string;

  return catId ? <ProductHomeLink /> : <CategoriesLink />;
}
